<template>
  <v-dialog :value="true" persistent content-class="welcomedialog" max-width="400">
    <v-card style="width: 400px">
      <br />
      <div align="center" class="primary--text">
        <h1>{{ $t("greeting") }}, {{ name }}!</h1>
      </div>
      <br />
      <v-img v-if="pic != '' && pic != null" :src="pic" :aspect-ratio="16 / 9" contain :style="{ cursor: 'pointer' }"></v-img>
      <br />
      <div v-if="message != ''">
        <h2>{{ message }}</h2>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
module.exports = {
  data: () => ({}),
  props: {
    name: String,
    pic: String,
    message: String
  }
};
//@ sourceURL=welcomeDialog.js
</script>

<style></style>
